/* DON'T EDIT THIS FILE: edit original and run build again */ import { toArray } from "../../framework/core/maybe-array.ts";
import {
  typeCheckerOkResult,
  typeCheckerSchemaFailResult,
} from "./type-checker-errors.ts";
import { typeCheckerResolveResult } from "./type-checker-resolve-result.ts";
import {
  TypeCheckerPrimitiveSchema,
  TypeCheckerResult,
  WithAnyTypeCheckerSchemaOptions,
} from "./type-checker-types.ts";

export const typeCheckerCheckPrimitive = (
  checker: WithAnyTypeCheckerSchemaOptions<TypeCheckerPrimitiveSchema>,
  value: unknown,
  path: string
): TypeCheckerResult => {
  const defaultValidator = (
    value: unknown,
    path: string
  ): TypeCheckerResult => {
    const type = typeof value;
    for (const primitive of toArray(checker.schema)) {
      if (type === primitive || (primitive === "null" && value === null)) {
        return typeCheckerOkResult(value);
      }
    }
    return typeCheckerSchemaFailResult(value, path);
  };
  const validator = checker.validator ?? defaultValidator;
  return typeCheckerResolveResult(checker, value, path, validator(value, path));
};
